import { useTranslation } from 'react-i18next';
import { CashRecoveryNotice } from './cash/CashRecoveryNotice';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { CashCurrentContextV1 } from '@pokerroom/types';
import { api } from '../../lib/api';
import { sessionVenueKey, useAuthStore } from '../../store/auth.store';
import { AdminPage, AdminPageHeader } from '../../components/layout/AdminPage';
import AccountingDayPanel from './AccountingDayPanel';
import { CashOpeningPanel } from './cash/CashOpeningPanel';
import { CountedOpeningPanel } from './cash/CountedOpeningPanel';

export default function DailyOpeningPage() {
  const { t } = useTranslation('accounting');
  const actor = useAuthStore((s) => s.user?.id),
    venue = useAuthStore((s) => sessionVenueKey(s.accessToken)),
    revision = useAuthStore((s) => s.sessionRevision);
  const canRead = useAuthStore((s) => s.allowedActions?.includes('accounting:read') === true);
  const [sourcePending, setSourcePending] = useState(false);
  const basis = useQuery({
    queryKey: ['accounting-business-day', actor, venue, revision],
    enabled: canRead,
    queryFn: () => api.get<{ cashContext: CashCurrentContextV1 }>('/accounting/business-day'),
  });
  const scope = `${actor}:${venue}:${revision}`;
  return (
    <AdminPage
      className="accounting-page"
      contentClassName="accounting-form-body space-y-6"
      header={<AdminPageHeader title={t('pageTitles.open')} description={t('counted.title')} />}
    >
      {canRead ? (
        <CountedOpeningPanel pageHeader key={`counted:${scope}`} blocked={sourcePending} />
      ) : (
        <CashRecoveryNotice error="DENIED" />
      )}
      {basis.data && (
        <CashOpeningPanel
          key={`source:${scope}`}
          context={basis.data.cashContext}
          recoveryOnly
          onPending={setSourcePending}
        />
      )}
      <AccountingDayPanel />
    </AdminPage>
  );
}
